

































import { Component, Prop, Vue } from 'vue-property-decorator';
import Person from './Person.vue';
import InfoBox from './InfoBox.vue';

@Component({
  components: {
    Person,
    InfoBox,
  },
})
export default class InfoSection extends Vue {
  data(){
    return {
      ...this.$store.state.customer
    }
  }
}
